import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return "-";
  }

  if (profile.email) {
    return profile.email;
  } else {
    return "-";
  }
};
//VERIFY IF THE JWT IS SET
const getMyEmailInfo = createSelector(getData, email => email);
export default getMyEmailInfo;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyEmailInfo.js